import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Grid } from "@material-ui/core";
import "./dialog-delete-domain.css";

/* === Custom component title for dialog === */
const CustomDeleteSignatureTitleBar = (props) => {
  const { t } = useTranslation();
  return (
    <div className="dialogDeleteDomain-title">
      <span>{t("dialogDeleteDomain.titleDeleteDomain")}</span>
    </div>
  );
};


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 * @descrption Layout for dialog  when user deletes domain
 */
const DialogDeleteDomainPure = (props) => {
  const { t } = useTranslation();

  return (
    <Dialog title={<CustomDeleteSignatureTitleBar />}>
      {/* <form> */}
      <div className="k-form">
        <div style={{ marginBottom: "14px" }}>
          <Grid container>
            {/* Label y TextArea */}
            <Grid
              item
              xs={12}
              style={{ textAlign: "center" }}
            >
              <p className="dialogDeleteDomain-text">
                ¿{t("dialogDeleteDomain.AreYouShureToDelete")}{" "}
                <span style={{ fontWeight: 600 }}>
                  {props.selectedDomain.name}
                </span>
                ?
              </p>
            </Grid>
          </Grid>
        </div>
        <div className="dialogDeleteDomain-btns-delete-container">
          <button
            className="dialogDeleteDomain-cancel-domain"
            onClick={() => props.toggleDialogDeleteDomain(false)}
          >
            {t("button.cancel")}
          </button>
          <button
            className="dialogDeleteDomain-accept-domain"
            type="submit"
            onClick={props.deleteDomain}
          >
            {t("button.accept")}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export { DialogDeleteDomainPure as default };
